/** @type {Record<string, string[]>} */
const ICONS = {
	swap: [
		'M7 4v13M7 17l-3-3M7 17l3-3',
		'M17 20V7M17 7l-3 3M17 7l3 3',
	],
	clock: [
		'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
		'M12 7v5l3 2',
	],
	coin: [
		'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
		'M12 7v10',
		'M9.2 9.2c0-1.1 1.3-1.7 2.8-1.7s2.8.6 2.8 1.7-1.3 1.7-2.8 1.7-2.8.6-2.8 1.7 1.3 1.7 2.8 1.7 2.8-.6 2.8-1.7',
	],
	sprout: [
		'M12 22V11',
		'M12 14c0-4-3-6-7-6 0 4 3 6 7 6z',
		'M12 11c0-4 3-6 7-6 0 4-3 6-7 6z',
		'M12 6V2',
	],
	inbox: [
		'M3 13h4l2 3h6l2-3h4',
		'M5 13V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7',
	],
	code: [
		'M8 6l-6 6 6 6',
		'M16 6l6 6-6 6',
	],
	leaf: [
		'M5 21c0-9 4-15 14-16-1 10-7 14-14 16z',
		'M5 21c3-6 7-10 12-12',
	],
	globe: [
		'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
		'M3 12h18',
		'M12 3c3 3 3 15 0 18-3-3-3-15 0-18z',
	],
	tag: [
		'M20.6 13.4 12.6 21.4a2 2 0 0 1-2.8 0L3 14.7V3h11.7l5.9 5.9a2 2 0 0 1 0 2.5z',
		'M7.5 6.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z',
	],
	phone: [
		'M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z',
		'M12 18h.01',
	],
	'bar-chart': [
		'M7 21V11',
		'M12 21V7',
		'M17 21V14',
	],
	map: [
		'M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z',
		'M9 4v14',
		'M15 6v14',
	],
};

/**
 * Small inline line icon for use-case cards.
 * @param {{ kind: string, className?: string }} props
 * @returns {JSX.Element}
 */
export function UseCaseIcon({ kind, className }) {
	const paths = ICONS[kind] ?? ICONS.swap;
	return (
		<svg
			className={className ? `use-case-icon ${className}` : 'use-case-icon'}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			{paths.map((d, i) => <path key={i} d={d} />)}
		</svg>
	);
}
